import React from 'react';
import { styled } from '@linaria/react';
import { ChevronRight } from 'lucide-react';
import { motion } from 'framer-motion';

import Expander from './Expander';

interface Props {
  name: string;
  slug: string;
  isExpanded: boolean;
  onClick: (slug: string) => void;
  children: React.ReactNode;
}

function Directory({
  name,
  slug,
  isExpanded,
  onClick,
  children,
}: Props) {
  return (
    <div>
      <Header onClick={() => onClick(slug)}>
        <Expander />
        <IconWrapper
          initial={false}
          animate={{ rotate: isExpanded ? 90 : 0 }}
        >
          <ChevronRight size={14} />
        </IconWrapper>
        {name}
      </Header>
      <Files
        initial={false}
        animate={{
          height: isExpanded ? 'auto' : 0,
          opacity: isExpanded ? 1 : 0,
          overflow: isExpanded ? undefined : 'hidden',
        }}
        style={{}}
      >
        {children}
      </Files>
    </div>
  );
}

const Header = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  height: var(--row-height);
  color: inherit;
`;

const Files = styled(motion.div)`
  padding-left: calc(16px + 4px);
  height: 0px;
`;

const IconWrapper = styled(motion.div)`
  svg {
    display: block;
  }
`;

export default Directory;
